/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { AnyAction } from '@reduxjs/toolkit';
import * as actionTypes from '../constants/action-types';
import { InitiativePlain, RootConfig, RootInitiativeData } from '../types/initiative';
import { AppConfig } from '../types/app';

interface GlobalData {
  initiativeTree: InitiativePlain[];
  organization?: RootInitiativeData;
  config?: RootConfig;
  appConfig?: AppConfig;
}

interface GlobalDataState {
  loaded: boolean;
  loading: boolean;
  errored: boolean;
  initiativeId: string;
  lastUpdated?: number;
  organization?: RootInitiativeData;
}

export interface GlobalDataStateLoaded extends GlobalDataState {
  loaded: true;
  data: GlobalData;
  organization: RootInitiativeData;
}

interface GlobalDataStateNotLoaded extends GlobalDataState {
  loaded: false;
  data: {};
}

const globalData = (
  state: (GlobalDataStateLoaded | GlobalDataStateNotLoaded) = {
    data: {},
    loaded: false,
    loading: false,
    errored: false,
    initiativeId: '',
  },

  action: AnyAction

): (GlobalDataStateLoaded | GlobalDataStateNotLoaded) => {

  switch (action.type) {
    case actionTypes.LOADING_GLOBALDATA:
      return {
        ...state,
        initiativeId: action.initiativeId,
        organization: action.organization,
        data: {},
        loading: true,
        loaded: false,
        errored: false,
        lastUpdated: action.lastUpdated
      }
    case actionTypes.ERROR_GLOBALDATA:
      return {
        ...state,
        loading: false,
        errored: true,
        loaded: false,
        lastUpdated: undefined
      }
    case actionTypes.LOADED_GLOBALDATA:
      return {
        ...state,
        data: action.data,
        organization: action.organization,
        errored: false,
        loading: false,
        loaded: true
      }
    default:
      return state;

  }

}

export default globalData;
